/*
 * @Author: xulihuan
 * @Date:   2017-09-21 11:19:03
 * @Last Modified by:   xulihuan
 * @Last Modified time: 2018-03-05 17:57:28
 */

import cm from 'cm'
import { axios as $http, setHeader } from 'cm'

import './style.scss'

/* 创建公共头部 */
// cm.setHeader({
//   el: document.body,
//   title: '咨询优惠券',
//   button: [
//     {
//       icon: 'back',
//       position: 'left',
//       callback () {
//         window.history.back();
//       }
//     }
//   ],
//   mode: 'before'
// });

let UA = navigator.userAgent
if (window.$platform.isWechat) {
  document.querySelector('title').innerText = '咨询优惠劵领取'
  document.querySelector('title').innerText = '咨询优惠劵领取'
} else if (window.$platform.isYixinliApp) {
  document.querySelector('title').innerText = '咨询优惠劵领取'
}

import { getRunTime } from '../../../public-resource/libs/utils/index'

import Bridge from '../../../public-resource/libs/Bridge/Bridge'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')

// 活动规则弹窗
var ruleBtn = document.getElementById('rule-btn')
var rulePopUp = document.querySelector('.rule-pop-up')
ruleBtn.onclick = function() {
  rulePopUp.style.display = 'block'
}
rulePopUp.onclick = function() {
  rulePopUp.style.display = 'none'
}

var getBtn = document.getElementById('get-btn')
var getBtnDisabled = document.getElementById('get-btn-disabled')

// 领取优惠券
var coupons = document.querySelectorAll('.coupon-pop-up')
getBtn.onclick = function() {
  $http
    .get(getCouponUrl + '?coupon_id=' + coupon_id)
    .then(res => {
      switch (res.data.code) {
        // 老客不可领
        case 40002:
          for (let i = 0; i < coupons.length; i++) {
            coupons[i].style.display = 'none'
          }
          document.getElementById('coupon-fail').style.display = 'block'
          this.style.display = 'none'
          getBtnDisabled.style.display = 'block'
          break
        // 新客已领取
        case 40000:
          for (let i = 0; i < coupons.length; i++) {
            coupons[i].style.display = 'none'
          }
          document.getElementById('coupon-received').style.display = 'block'
          this.style.display = 'none'
          getBtnDisabled.style.display = 'block'
          break
        // 领取失败
        case 1:
          for (let i = 0; i < coupons.length; i++) {
            coupons[i].style.display = 'none'
          }
          window.toast('优惠券领取失败')
          break
        // 优惠券不存在
        case 20002:
          for (let i = 0; i < coupons.length; i++) {
            coupons[i].style.display = 'none'
          }
          window.toast('优惠券不存在')
          break
        // 领取成功
        case 0:
          var discount = res.data.data.price
          for (let i = 0; i < coupons.length; i++) {
            coupons[i].style.display = 'none'
          }
          this.style.display = 'none'
          getBtnDisabled.style.display = 'block'
          if (discount == 20) {
            document.getElementById('coupon-20').style.display = 'block'
          } else if (discount == 50) {
            document.getElementById('coupon-50').style.display = 'block'
          } else if (discount == 100) {
            document.getElementById('coupon-100').style.display = 'block'
          }
          break
      }
    })
    .catch(err => {
      console.log(err)
      window.toast('优惠券领取失败')
    })
}

for (let i = 0; i < coupons.length; i++) {
  coupons[i].onclick = function() {
    this.style.display = 'none'
  }
}

// 微信分享
if (window.$platform.isWechat) {
  let currentUrl = document.location.href
  let getWxConfig = `${HOST}/wx/get-wx-package.json`
  $http
    .get(getWxConfig + '?url=' + encodeURIComponent(currentUrl))
    .then(res => {
      if (res.data.code == 0) {
        var wxConfig = res.data.data
        function loadScript(url, callback) {
          var script = document.createElement('script')
          script.type = 'text/javascript'
          if (typeof callback !== 'undefined') {
            if (script.readyState) {
              script.onreadystatechange = function() {
                if (
                  script.readyState == 'loaded' ||
                  script.readyState == 'complete'
                ) {
                  script.onreadystatechange = null
                  callback()
                }
              }
            } else {
              script.onload = function() {
                callback()
              }
            }
          }
          script.src = url
          document.body.appendChild(script)
        }

        setTimeout(() => {
          loadScript('//res.wx.qq.com/open/js/jweixin-1.6.0.js', () => {
            var _config = {
              debug: wxConfig.debug,
              appId: wxConfig.appId,
              timestamp: wxConfig.timestamp,
              nonceStr: wxConfig.nonceStr,
              signature: wxConfig.signature,
              jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareWeibo',
                'onMenuShareQZone',
                'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
                'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            }

            // 微信基本配置信息
            wx.config(_config)

            wx.ready(function() {
              var shareConfig = {
                title: '壹心理首单咨询限时优惠',
                desc: '20位资深心理咨询师送来开年红包,最高100元!',
                link: window.location.href,
                imgUrl:
                  'https://ossimg.xinli001.com/20180305/8cf65cbf880708abb1697544d8ee358a.png',
                success: function(res) {},
                cancel: function(res) {},
                fail: function(res) {}
              }
              // 分享到朋友圈
              wx.onMenuShareTimeline(shareConfig)
              // 分享给朋友
              wx.onMenuShareAppMessage(shareConfig)
              // 分享到QQ
              wx.onMenuShareQQ(shareConfig)
              // 分享到腾讯微博
              wx.onMenuShareWeibo(shareConfig)
              // 分享到QQ空间
              wx.onMenuShareQZone(shareConfig)
              wx.updateAppMessageShareData(shareConfig)
              wx.updateTimelineShareData(shareConfig)
            })
          })
        }, 500)
      }
    })
}

// APP分享
if (window.$platform.isYixinliApp) {
  var myBrige = new Bridge({
    methods: [
      {
        method: 'topFuncBtn',
        callback: function(ops) {
          if (ops.name == 'shareReportBtn') {
            var share_config = {
              link: window.location.href,
              imgUrl:
                'https://ossimg.xinli001.com/20180305/8cf65cbf880708abb1697544d8ee358a.png',
              desc: '20位资深心理咨询师送来开年红包,最高100元!',
              title: '壹心理首单咨询限时优惠'
            }
            myBrige.call('shareReport', share_config)
          }
        }
      }
    ]
  })
  myBrige.call('topFuncBtnConfig', {
    btnList: [
      {
        name: 'shareReportBtn',
        visible: 1
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/pages/promotion/consultNewYearCoupon/index.js